import { render, staticRenderFns } from "./TraxUiHorizontalTabs.vue?vue&type=template&id=22b4b3cc"
import script from "./TraxUiHorizontalTabs.vue?vue&type=script&lang=js"
export * from "./TraxUiHorizontalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports